export default {
  tabs: {
    calendar: 'เวลาของฉัน',
    list: 'ประวัติรายการและสถานะ',
    approve: 'อนุมัติเวลา',
    'approver-calendar': 'ปฏิทินอนุมัติ'
  },
  dataState: {
    loading: 'กำลังโหลด…',
    failed: 'โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่',
    empty: 'ไม่มีรายการ',
    retry: 'ลองใหม่'
  },
  title: 'E-Time',
  report: 'รายงาน',
  selectedStatuses: 'เลือก {{count}} สถานะ',
  radio: {
    calendar: 'ปฏิทิน',
    list: 'รายการ',
    export: 'ส่งออก'
  },
  modal: {
    title: 'บันทึก'
  },
  option: {
    'Request/Edit Time': 'ขอเพิ่ม/แก้ไขเวลา',
    'Request OT': 'ขอเพิ่มโอที',
    'Request Special Allowance': 'ขอเพิ่มเงินได้พิเศษ'
  }
}
